import React from "react";
import PropTypes from "prop-types";
import UserDataService from "../common/UserDataService";
import {fetchResponseHandler} from "../../util/FetchUtil";
import ProcessingComponent from "../../util/ProcessingComponent";
import Duo from "./Duo-Web-v2.min";
/*
* This is for DUO Traditional Prompt.
* Note: This will be replaced by DuoAuthSetupComponent.js.
*/
class DuoSetupComponent extends React.Component {
    constructor(props){
        super(props);
        this.state = {};
        this.setShowProcessing = this.setShowProcessing.bind(this);
        this.hideProcessing = this.hideProcessing.bind(this);
        this.showProcessing = this.showProcessing.bind(this);
    }

    setShowProcessing(showProcessing){
        this.setState(state => ({...state, showProcessing}));
    }

    hideProcessing(){
        this.setShowProcessing(false);
    }

    showProcessing(){
        this.setShowProcessing(true);
    }

    componentDidMount() {
        const {userDataService, onError, onSuccess} = this.props;
        this.showProcessing();
        userDataService.getDuoInitData()
            .then(fetchResponseHandler)
            .then(data => {
                const {mfaHostUrl, signature} = data;
                Duo.init({
                    host: mfaHostUrl,
                    sig_request: signature,
                    submit_callback: onSuccess
                });
            })
            .catch(onError)
            .finally(this.hideProcessing);
    }

    render(){
        const {showProcessing} = this.state;
        const {onCancel} = this.props;
        return (
            <div>
                <iframe ref="duoIframe" id="duo_iframe" className="duo-width"></iframe>
                {
                    onCancel &&
                    <div className="duo-width text--center push--top">
                        <button className="btn btn--link" onClick={onCancel}>Cancel</button>
                    </div>
                }
                <ProcessingComponent show={showProcessing} />
            </div>
        );
    }

}

DuoSetupComponent.propTypes = {
    userDataService: PropTypes.instanceOf(UserDataService).isRequired,
    onError: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onCancel: PropTypes.func
};

export default DuoSetupComponent;